import { useLayoutStore } from '@modules/core/store';
import { ReactNode, useEffect } from 'react';
import {
  Box, Flex, Text
} from '@huspy/briks-web';
import { Outlet } from '@tanstack/react-router';
import ProgressionStepper from '@components/v2/ProgressionStepper';
import { FileText } from '@huspy/briks-icons';
import { useTranslation } from 'react-i18next';
import { ProposalCreationContext } from '../context';

type Props = {
  children?: ReactNode,
};

const ProposalCreationLayoutEs = (_: Props) => {
  const { t } = useTranslation();
  const { setAsideContent, setHeaderContent, asideContent } = useLayoutStore();

  useEffect(() => {
    setHeaderContent(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setAsideContent(
      <Flex gap={ 10 } direction='column'>
        <ProgressionStepper
          routeId='editable-template'
          links={ [
            {
              icon: <FileText height={ 20 } width={ 20 } color='inherit' />,
              to: '#',
              name: t('proposals.asideContent.steps.review.title'),
              isAccessible: false,
              sublinks: [],
              isComplete: true,
            }
          ] }
          header={ (
            <Text size='4xl' weight='medium'>
              {t('proposals.asideContent.title')}
            </Text>
          ) }
          isLoading={ false }
        />
      </Flex>
    );

    return () => {
      setAsideContent(null);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!asideContent) {
    return null;
  }

  return (
    <Box h='100%'>
      {/* eslint-disable-next-line react/jsx-no-constructed-context-values */}
      <ProposalCreationContext.Provider value={ {
        goToNextState: () => {},
        goToPreviousState: () => {},
        unlockNextStateAndNavigate: () => {},
      } }
      >
        <Outlet />
      </ProposalCreationContext.Provider>
    </Box>
  );
};

export default ProposalCreationLayoutEs;
